import FlatList from 'flatlist-react';
import React, { useCallback, useEffect, useMemo, useLayoutEffect, useState } from "react";
import { connect } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from '@mui/material';

import StudentClassCard from "components/StudentClassCard";
import styled from 'styled-components';
import { Col, Drawer, Row } from 'antd';
import { handleSyncSchoologyClasses } from 'store/schoology/thunks';
import { makeStyles } from 'utils/styles/mui';
import SentryWrap from "components/Sentry";

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------








import {  filter } from "lodash"



const Navigation = styled.ul`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100%;
  list-style-type: none;
  margin: 0px;
  padding: 0px;
`;

const StyledDrawer = styled(Drawer)`
  @media (min-width: 1367px) {
    // display: none;
  }
`;

const CenterContainer = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
`;
const ButtonClear = styled.button`
    border-radius: 7px;
    color: #fff;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 10px;
    margin: 10px;
`;
const AnimatedArrowContainer = styled.div`
  margin: 0 auto;
  text-align: center;
  width: 100px;
  height: 100px;
  position: relative;
  cursor: pointer;
  filter: url("#goo");
`;

const AnimatedArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
`;


const ArrowCircle = styled.div`
    background: #582f81;
    border-radius: 50%;
    display: inline-block;
    height: 100px;
    width: 100px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    transform-origin: 0%;
`;

const ArrowCircleTop = styled(ArrowCircle)`
  height: 33.33px;
  width: 41.67px;
  animation: blob-1-anim 3s cubic-bezier(0.77, 0, 0.175, 1) infinite;
  z-index: 0;
  top: 0;
`;

const ArrowCircleBottom = styled(ArrowCircle)`
  height: 33.33px;
  width: 41.67px;
  animation: blob-2-anim 3s cubic-bezier(0.77, 0, 0.175, 1) infinite;
  z-index: 9;
  bottom: 0px;
`;

const ArrowSvg = styled.svg`
  z-index: 9;
  position: relative;
  background: #582f81;
  border-radius: 50%;
  display: inline-block;
  height: 100px;
  width: 100px;

  .st-arrow {
    fill: #fff;
    animation: scrolly 3s cubic-bezier(0.77, 0, 0.175, 1) forwards infinite;
    perspective: 9000px;
    transform: translateZ(0);
    transform-origin: bottom;
  }
`;

const AnimatedArrowBottom = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  transform: ${props => props.isAtBottom ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: transform 0s ease;
`;
const useStyles = makeStyles((theme) => ({
    titleText: {
        fontWeight: 400,
        color: 'rgb(255, 255, 255)',
        fontSize: 20,
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 17
    }
}));

const AnimatedArrow = ({ onClick, direction }) => {
    const isUp = direction === 'up';
  
    return (
      <AnimatedArrowContainer onClick={onClick} className={`animated-arrow ${!isUp ? "up" : ""}`}>
        <AnimatedArrowBottom isAtBottom={isUp}>
          <ArrowCircleTop />
          <ArrowCircle className="circle-top" />
          <ArrowCircle className="circle-main" />
          <ArrowCircle className="circle-bottom" />
          <ArrowCircleBottom />
          <ArrowSvg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 612 612"
            style={{ enableBackground: "new 0 0 612 612" }}
            xmlSpace="preserve"
          >
            {/* same defs and filter */}
            <path
              className="st-arrow"
              d="M317.5,487.6c0.3-0.3,0.4-0.7,0.7-1.1l112.6-112.6c6.3-6.3,6.3-16.5,0-22.7c-6.3-6.3-16.5-6.3-22.7,0
                  l-86,86V136.1c0-8.9-7.3-16.2-16.2-16.2c-8.9,0-16.2,7.3-16.2,16.2v301.1l-86-86c-6.3-6.3-16.5-6.3-22.7,0
                  c-6.3,6.3-6.3,16.5,0,22.7l112.7,112.7c0.3,0.3,0.4,0.7,0.7,1c0.5,0.5,1.2,0.5,1.7,0.9c1.7,1.4,3.6,2.3,5.6,2.9
                  c0.8,0.2,1.5,0.4,2.3,0.4C308.8,492.6,313.8,491.3,317.5,487.6z"
            />
          </ArrowSvg>
          <style jsx>{`
          .animated-arrow {
            text-align: center;
            width: 100px;
            height: 100px;
            position: relative;
            cursor: pointer;
            filter: url("#goo");
          }
  
          .animated-arrow.down {
            transform: rotate(180deg);
          }
  
          .arrow-body {
            position: absolute;
            left: 50%;
            top: 10px;
            animation: blob-1-anim 2s infinite ease-in-out;
            transform: translateX(-50%);
          }
  
          .circle-top,
          .circle-main,
          .circle-bottom {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #ccc;
            position: absolute;
            left: 50%;
          }
  
          .circle-top {
            top: 0;
            animation: blob-2-anim 2s infinite ease-in-out;
          }
  
          .circle-main {
            top: 20px;
          }
  
          .circle-bottom {
            top: 40px;
            animation: rotate-circle 4s linear infinite;
          }
  
          .arrow-svg {
            width: 40px;
            height: 40px;
            position: absolute;
            top: 60px;
            left: 50%;
            transform: translateX(-50%);
            animation: scrolly 3s infinite ease-in-out;
          }
  
          .st-arrow {
            fill: #000;
          }
  
          @keyframes blob-1-anim {
            0% {
              transform: translateX(-50%) translateY(0);
            }
            14% {
              transform: translateX(-50%) translateY(-8px);
            }
            24% {
              transform: translateX(-50%) translateY(0);
            }
            100% {
              transform: translateX(-50%) translateY(0);
            }
          }
  
          @keyframes blob-2-anim {
            0%,
            30%,
            70% {
              transform: scale(1) translate(-50%, 10px);
            }
            95% {
              transform: scale(1) translate(-50%, 26px);
            }
            100% {
              transform: scale(1) translate(-50%, 10px);
            }
          }
  
          @keyframes scrolly {
            0% {
              transform: translate3d(0, -150%, 0) rotateX(90deg) scale(0.5)
                skewX(3deg);
            }
            30%,
            70% {
              transform: translate3d(0, 0, 0) rotateX(0deg) scale(1) skewX(0deg);
            }
            95%,
            100% {
              transform: translate3d(0, 50%, 0) rotateX(-90deg) scale(0.5)
                skewX(-3deg);
            }
          }
  
          @keyframes rotate-circle {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(180deg);
            }
          }
        `}</style>
        </AnimatedArrowBottom>
      </AnimatedArrowContainer>
    );
  };

function LearnScreen({
    currentUser,
    userClasses,
    fromDrawer = false,
    openMenuClass,
    visible,
    onCloseMenuBook = () => {},
    from_menu=false
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const [canScroll, setCanScroll] = useState(false);
    const [showDownArrow, setShowDownArrow] = useState(true);
    const [showUpArrow, setShowUpArrow] = useState(false);
   const class_list = useMemo(()=>filter(userClasses,k=>!k.archived&&k.userclass.active),[userClasses])
    const renderItem = useCallback((item, index) => {
        return (<StudentClassCard key={item.id} classInfo={item} fromDrawer={fromDrawer} />)
    },[userClasses, fromDrawer])

    const redirectToHome = () => {
        navigate(`/student/class`);
    }
    useEffect(() => {
      if(from_menu) return
        if (userClasses && Array.isArray(userClasses)) {
            const unarchive_classes = userClasses.filter(cls => !cls.archived)
            if (unarchive_classes.length == 1) {
                redirectToHome()
            }
        }
    }, [userClasses,from_menu])
    useEffect(() => {
        if (currentUser && currentUser?.schoologyid) {
          handleSyncSchoologyClasses(currentUser?.schoologyid)
        }
      }, [currentUser])

    useEffect(() => {
        onCloseMenuBook();
    }, [location.key]);

    useLayoutEffect(() => {
        const handleResize = () => {
            onCloseMenuBook();
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []); 


    const updateArrowVisibility = (wrapper) => {
        const { scrollTop, scrollHeight, clientHeight } = wrapper;
        const isAtTop = scrollTop <= 10;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
        
        setShowUpArrow(!isAtTop);
        setShowDownArrow(!isAtBottom);
    };
        
        const handleScroll = (direction = "down") => {
        //   if (!fromDrawer) return;
        
          const popoverContent = document.querySelector(
            ".custom-popover .ant-popover-inner-content"
          );
          if (!popoverContent) return;
        
          const popoverWrapper = Array.from(popoverContent.children).find(
            (child) => child.scrollHeight > child.clientHeight
          );
          if (!popoverWrapper) return;
        
          const scrollAmount = popoverWrapper.clientHeight * 0.9;
          popoverWrapper.scrollBy({
            top: direction === "down" ? scrollAmount : -scrollAmount,
            behavior: "smooth",
          });
        
          setTimeout(() => updateArrowVisibility(popoverWrapper), 400);
        };
        
        useEffect(() => {
        //   if (!fromDrawer) return;
        
          const popoverContent = document.querySelector(
            ".custom-popover .ant-popover-inner-content"
          );
          const popoverWrapper = Array.from(popoverContent?.children || []).find(
            (child) => child.scrollHeight > child.clientHeight
          );
          if (!popoverWrapper) return;
        
          updateArrowVisibility(popoverWrapper);
        
          const onScroll = () => updateArrowVisibility(popoverWrapper);
        
          popoverWrapper.addEventListener("scroll", onScroll);
          return () => popoverWrapper.removeEventListener("scroll", onScroll);
        }, [fromDrawer]);

    return (
        <SentryWrap>
        {!fromDrawer && visible && (
        <div
            id="animated-arrow-container"
            style={{
            position: "absolute",
            left: "50%",
            bottom: "-50px",
            transform: "translate(-50%) scale(0.5)",
            zIndex: 1000,
            }}
        >
                  
            <AnimatedArrowWrapper>
            {showDownArrow && (
                <AnimatedArrow direction="down" onClick={() => handleScroll("down")} />
            )}
            {showUpArrow && (
                <AnimatedArrow direction="up" onClick={() => handleScroll("up")} />
            )}
            </AnimatedArrowWrapper>

        </div>
        )}
        {fromDrawer ? (
        <StyledDrawer
        placement={"right"}
        onClose={onCloseMenuBook}
        open={openMenuClass}
        className="HeaderMenuMObileClass studentHeaderMenuMObileClass"
        forceRender
      >
        <Navigation className="mobileMenuSection">
            <Row className={`${!fromDrawer && "teacherHm" }`}>
                <Col xs={24} sm={24} md={24} lg={24}>
                    <Row>
                        <div className="techrHmBtn studentHomecls 111">
                            <Button>My classes</Button>
                        </div>
                    </Row>
                    <Row className="teacherHmInr allStudentHome allStudentHomeCstm" gutter={[40, 50]} style={{marginBottom:80}}>
                    {/* paddingLeft:16,  */}
                        <FlatList
                            list={class_list}
                            renderItem={renderItem}
                            renderWhenEmpty={() => <div>No classes available</div>}
                            sortBy={["id"]}
                        />
                    </Row>
                </Col>
                {/* <Col xs={24} sm={24} md={24} lg={4}></Col> */}
            </Row>
        </Navigation>
        </StyledDrawer>
        ) : (
            <>
            <div className='myClassesStudent'>
              <Button>My classes</Button>
            </div>
            <Row className={`${!fromDrawer && "teacherHm" }`}>
                <Col xs={24} sm={24} md={24} lg={24}>
                    <Row className="teacherHmInr allStudentHome allStudentHomeCstm" gutter={[40, 50]} style={{marginBottom:80}}>
                    {/* paddingLeft:16,  */}
                        <FlatList
                            list={class_list}
                            renderItem={renderItem}
                            renderWhenEmpty={() => <div>No classes available</div>}
                            sortBy={["id"]}
                        />
                    </Row>
                </Col>
                {/* <Col xs={24} sm={24} md={24} lg={4}></Col> */}
            </Row>
            </>
        )}
        </SentryWrap>
    );
}

const mapStateToProps = state => ({
    currentUser: state.currentUser,
    userClasses: state.userClasses,
});

export default connect(mapStateToProps, null)(LearnScreen);